import {
    CreateOrReplaceDevBoxAddOnResponse,
    EnableDevBoxAddOnResponse,
    GetDevBoxAddOnResponse,
    ListDevBoxAddOnsResponse,
} from '../../../data/services/data-plane-api/add-ons';
import { DevBoxAddOn } from '../../../models/add-ons';
import { AggregatedResult } from '../../../models/common';
import { createActionCreator, createActionCreatorWithoutPayload } from '../core-action-creators';
import { ErrorPayload, FailedPayload, IndexedPayload, PollPayload, ResultPayload } from '../core-actions';
import {
    CreateOrReplaceDevBoxAddOnPayload,
    DevBoxAddOnsActionType,
    EnableDevBoxAddOnAcceptedPayload,
    EnableDevBoxAddOnPayload,
    EnableDevBoxAddOnWithPollingPayload,
    EnableDevBoxTunnelErrorPayload,
    EnableDevBoxTunnelFailedPayload,
    EnableDevBoxTunnelSuccessPayload,
    EnableTunnelPayload,
    GetDevBoxAddOnPayload,
    ListAddOnsSuccessPayload,
    PollNonTerminalDevBoxAddOnCompletePayload,
} from './add-ons-actions';

/**
 * Add ons action creators
 */
export const listDevBoxAddOns = createActionCreator<IndexedPayload, ListDevBoxAddOnsResponse>(
    DevBoxAddOnsActionType.ListDevBoxAddOns,
    { async: true, startsActivity: true }
);

export const listDevBoxAddOnsError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.ListDevBoxAddOnsError
);
export const listDevBoxAddOnsFailed = createActionCreator<FailedPayload & IndexedPayload>(
    DevBoxAddOnsActionType.ListDevBoxAddOnsFailed
);

export const listDevBoxAddOnsSuccess = createActionCreator<ListAddOnsSuccessPayload>(
    DevBoxAddOnsActionType.ListDevBoxAddOnsSuccess
);

export const loadDevBoxAddOnsForDevBoxes = createActionCreatorWithoutPayload<AggregatedResult>(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxes,
    { async: true }
);

export const loadDevBoxAddOnsForDevBoxesError = createActionCreator<ErrorPayload>(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxesError
);

export const loadDevBoxAddOnsForDevBoxesFailed = createActionCreator<FailedPayload>(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxesFailed
);

export const loadDevBoxAddOnsForDevBoxesSuccess = createActionCreatorWithoutPayload(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxesSuccess
);

export const pollNonTerminalDevBoxAddOn = createActionCreator<
    IndexedPayload & PollPayload & { name: string },
    GetDevBoxAddOnResponse
>(DevBoxAddOnsActionType.PollNonTerminalDevBoxAddOn, { async: true, startsActivity: true });

export const pollNonTerminalDevBoxAddOnComplete = createActionCreator<PollNonTerminalDevBoxAddOnCompletePayload>(
    DevBoxAddOnsActionType.PollNonTerminalDevBoxAddOnComplete
);

export const pollNonTerminalDevBoxAddOnError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.PollNonTerminalDevBoxAddOnError
);

export const getDevBoxAddOn = createActionCreator<GetDevBoxAddOnPayload, GetDevBoxAddOnResponse>(
    DevBoxAddOnsActionType.GetDevBoxAddOn,
    { async: true, startsActivity: true }
);

export const getDevBoxAddOnError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.GetDevBoxAddOnError
);

export const getDevBoxAddOnFailed = createActionCreator<FailedPayload & IndexedPayload>(
    DevBoxAddOnsActionType.GetDevBoxAddOnFailed
);

export const getDevBoxAddOnSuccess = createActionCreator<IndexedPayload & ResultPayload<DevBoxAddOn>>(
    DevBoxAddOnsActionType.GetDevBoxAddOnSuccess
);

export const enableDevBoxAddOn = createActionCreator<EnableDevBoxAddOnPayload, EnableDevBoxAddOnResponse>(
    DevBoxAddOnsActionType.EnableDevBoxAddOn,
    { async: true, startsActivity: true }
);

export const enableDevBoxAddOnAccepted = createActionCreator<EnableDevBoxAddOnAcceptedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnAccepted
);

export const enableDevBoxAddOnError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnError
);

export const enableDevBoxAddOnFailed = createActionCreator<FailedPayload & IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnFailed
);

export const enableDevBoxAddOnSuccess = createActionCreator<IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnSuccess
);

export const enableDevBoxAddOnWithPolling = createActionCreator<
    EnableDevBoxAddOnWithPollingPayload,
    EnableDevBoxAddOnResponse
>(DevBoxAddOnsActionType.EnableDevBoxAddOnWithPolling, { async: true, startsActivity: true });

export const enableDevBoxAddOnWithPollingError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnWithPollingError
);

export const enableDevBoxAddOnWithPollingFailed = createActionCreator<FailedPayload & IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnWithPollingFailed
);

export const enableDevBoxAddOnWithPollingSuccess = createActionCreator<IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxAddOnWithPollingSuccess
);

/**
 * Create or Replace DevBox AddOn action creators
 */
export const createOrReplaceDevBoxAddOn = createActionCreator<
    CreateOrReplaceDevBoxAddOnPayload,
    CreateOrReplaceDevBoxAddOnResponse
>(DevBoxAddOnsActionType.CreateOrReplaceDevBoxAddOn, { async: true, startsActivity: true });

export const createOrReplaceDevBoxAddOnError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.CreateOrReplaceDevBoxAddOnError
);

export const createOrReplaceDevBoxAddOnFailed = createActionCreator<FailedPayload & IndexedPayload>(
    DevBoxAddOnsActionType.CreateOrReplaceDevBoxAddOnFailed
);

export const createOrReplaceDevBoxAddOnSuccess = createActionCreator<IndexedPayload & ResultPayload<DevBoxAddOn>>(
    DevBoxAddOnsActionType.CreateOrReplaceDevBoxAddOnSuccess
);

/**
 * Tunnel action creators
 */
export const enableDevBoxTunnel = createActionCreator<EnableTunnelPayload, EnableDevBoxTunnelSuccessPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnel,
    {
        async: true,
        startsActivity: true,
    }
);

export const enableDevBoxTunnelError = createActionCreator<EnableDevBoxTunnelErrorPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelError
);

export const enableDevBoxTunnelFailed = createActionCreator<EnableDevBoxTunnelFailedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelFailed
);

export const enableDevBoxTunnelSuccess = createActionCreator<EnableDevBoxTunnelSuccessPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelSuccess
);

/**
 * Tunnel phase action creators - for tracking progress of tunnel enablement
 */
export const enableDevBoxTunnelPhaseStartDevBox = createActionCreator<IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelPhaseStartDevBox
);

export const enableDevBoxTunnelPhaseTunnelEnabling = createActionCreator<IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelPhaseTunnelEnabling
);

export const enableDevBoxTunnelPhaseTunnelEnablingFinished = createActionCreator<IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelPhaseTunnelEnablingFinished
);

export const enableDevBoxTunnelPhaseTunnelNotEnabled = createActionCreator<IndexedPayload>(
    DevBoxAddOnsActionType.EnableDevBoxTunnelPhaseTunnelNotEnabled
);
